import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FiMenu, FiX, FiPhone, FiMail } from 'react-icons/fi';
import { useReservation } from '../contexts/ReservationContext';
import Logo from './Logo';
import './Navigation.css';

const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  const { open: openReservation } = useReservation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMenuOpen(false);
  }, [location]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const scrollToSection = (sectionId) => {
    if (location.pathname !== '/') {
      window.location.href = `/#${sectionId}`;
      return;
    }
    
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    setIsMenuOpen(false);
  };

  const navItems = [
    { label: 'Accueil', href: '/', sectionId: 'accueil' },
    { label: 'Services', href: '#services', sectionId: 'services' },
    { label: 'Véhicules', href: '#vehicules', sectionId: 'vehicules' },
    { label: 'Blog', href: '/blog', isLink: true },
    { label: 'FAQ', href: '#faq', sectionId: 'faq' },
    { label: 'Contact', href: '/contact', isLink: true },
  ];

  return (
    <nav className={`navigation ${isScrolled ? 'scrolled' : ''}`}>
      <div className="nav-container">
        <Link to="/" className="nav-logo" aria-label="VIP Limousine Paris — Accueil">
          <Logo />
        </Link>

        <div className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
          {navItems.map((item, index) =>
            item.isLink ? (
              <Link
                key={index}
                to={item.href}
                className="nav-link"
                onClick={() => setIsMenuOpen(false)}
              >
                {item.label}
              </Link>
            ) : (
              <button
                key={index}
                onClick={() => scrollToSection(item.sectionId)}
                className="nav-link"
              >
                {item.label}
              </button>
            )
          )}
          
          <div className="nav-contact">
            <a href="tel:+33661630113" className="contact-link">
              <FiPhone size={16} />
              <span>06 61 63 01 13</span>
            </a>
            <a href="mailto:contact@limousine-vip-paris.fr" className="contact-link">
              <FiMail size={16} />
              <span>Contact</span>
            </a>
          </div>

          <button
            type="button"
            onClick={() => {
              openReservation();
              setIsMenuOpen(false);
            }}
            className="btn btn-primary nav-cta"
          >
            Réserver
          </button>
        </div>

        <button className="menu-toggle" onClick={toggleMenu}>
          {isMenuOpen ? <FiX size={24} /> : <FiMenu size={24} />}
        </button>
      </div>
    </nav>
  );
};

export default Navigation;
